import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash'
import { retry } from 'rxjs';
@Pipe({
    name: 'orderBy',
    pure: false,
    standalone: true
})
export class OrderByPipe implements PipeTransform {

  transform(value: any, field?:string ,order?: string): any {
    order = order?order:'asc'
    if(field){
      return _.orderBy(value,[field],[order]);
    }else{
      return value
    }
    
  }

}
